<template>
  <AppLayout
    :parent="parent"
    class="offers offers-references"
    :title="candidateName"
    :isLoading="isFetchingCurrentOffer"
    centered
    isDetails
    smallTitle
  >
    <template v-slot:header>
      <p class="ml-2 mb-0">
        {{ role }}
      </p>
    </template>
    <template v-slot:body>
      <div
        class="container"
        v-if="isFetchingCurrentOffer || isFetchingUserReferences"
      >
        <v-skeleton-loader v-for="i in 5" :key="i" type="list-item" />
      </div>
      <div class="container mt-0 pt-0" v-else>
        <v-divider />
        <div class="row mx-auto justify-center align-center">
          <h1>{{ step.name }}</h1>
          <Chip :status="step.status" class="chip--status ml-2">
            {{ step.status }}
          </Chip>
        </div>
        <div class="mt-12">
          <Reference
            v-for="reference in references"
            :key="reference.id"
            :reference="reference"
            :candidate="candidate"
            @updated="updateReferences"
          />
        </div>
        <BaseFooter>
          <ExpandedButtons>
            <Permissioned
              :vertical="isMobile"
              section="offers"
              class="actions-bar"
            >
              <AddReferenceAction
                permission="step.add-details"
                :candidate="candidate"
                @created="addNewReference"
              />
              <MarkAsCompleteAction
                :stepId="step.id"
                @updated="updateReferences"
                permission="step.mark-as-complete"
              />
              <RequestReferences permission="request-reference" />
            </Permissioned>
          </ExpandedButtons>
        </BaseFooter>
      </div>
    </template>
  </AppLayout>
</template>
<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import Chip from "@/components/common/Chip";
import Reference from "@/views/offers/components/compliances/references/ReferenceItem";
import BaseFooter from "@/components/common/BaseFooter";
import AddReferenceAction from "@/views/offers/components/compliances/actions/AddReferenceAction";
import MarkAsCompleteAction from "@/views/offers/components/compliances/actions/MarkAsCompleteAction";
import Permissioned from "@/components/common/Permissioned";
import { FETCH_CURRENT_OFFER } from "@/store/modules/offers/actions";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { createNamespacedHelpers } from "vuex";
import { getFullName } from "@/utils/users";
import { getCurrentStep, getReferences } from "@/utils/offers";
import { FORM_NAMES } from "@/constants/offers";
import { FETCH_USER_REFERENCES } from "@/store/modules/references/actions";
import { REFERENCES_NAMESPACE } from "@/store/modules/references";
import { copyState } from "@/utils/helpers";
import RequestReferences from "@/views/offers/actions/RequestReferencesAction";
import ExpandedButtons from "@/components/common/ExpandedButtons";

const { mapActions, mapState } = createNamespacedHelpers(OFFERS_NAMESPACE);
const {
  mapActions: referenceActions,
  mapState: referenceState
} = createNamespacedHelpers(REFERENCES_NAMESPACE);
const { REFERENCES } = FORM_NAMES;

export default {
  components: {
    AppLayout,
    Chip,
    Reference,
    BaseFooter,
    AddReferenceAction,
    MarkAsCompleteAction,
    RequestReferences,
    Permissioned,
    ExpandedButtons
  },
  async created() {
    await this.fetchCurrentOffer(this.offerId);
    await this.fetchUserReferences(this.candidate.id);
    this.references = getReferences(this.currentUserReferences);
    this.step = this.getCurrentStep(this.currentOffer, REFERENCES);
  },
  data() {
    return {
      dialogSettings: { dialog: false },
      step: {},
      references: []
    };
  },
  computed: {
    ...mapState(["currentOffer", "isFetchingCurrentOffer"]),
    ...referenceState(
      copyState(["currentUserReferences", "isFetchingUserReferences"])
    ),
    application() {
      return this.currentOffer.application || {};
    },
    role() {
      return this.application ? this.application.booking.title : "";
    },
    candidateName() {
      return this.candidate ? getFullName(this.candidate) : "";
    },
    candidate() {
      return this.application.user;
    },
    offerId() {
      return this.$route.params.id;
    },
    parent() {
      return `/offers/${this.offerId}`;
    }
  },
  methods: {
    ...mapActions({
      fetchCurrentOffer: FETCH_CURRENT_OFFER
    }),
    ...referenceActions({
      fetchUserReferences: FETCH_USER_REFERENCES
    }),
    handleEdit() {
      this.dialogSettings.dialog = true;
      this.dialogSettings.title = this.title;
    },
    async updateReferences() {
      await this.fetchUserReferences(this.candidate.id);
      this.references = getReferences(this.currentUserReferences);
    },
    addNewReference(newReference) {
      this.references.push(newReference);
    },
    getCurrentStep
  }
};
</script>

<style lang="scss"></style>
